import { render, staticRenderFns } from "./userReset.vue?vue&type=template&id=3174012c&"
import script from "./userReset.vue?vue&type=script&lang=js&"
export * from "./userReset.vue?vue&type=script&lang=js&"
import style0 from "./userReset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports